'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _reduxForm = require('redux-form');

var _FieldForm = require('../form/FieldForm');

var _FieldForm2 = _interopRequireDefault(_FieldForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @deprecated
 */
var McField = function (_Field) {
    (0, _inherits3.default)(McField, _Field);

    function McField() {
        (0, _classCallCheck3.default)(this, McField);
        return (0, _possibleConstructorReturn3.default)(this, (McField.__proto__ || (0, _getPrototypeOf2.default)(McField)).apply(this, arguments));
    }

    return McField;
}(_reduxForm.Field);
// import FormField from './FormField'


McField.defaultProps = {
    component: _FieldForm2.default
};
exports.default = McField;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9saWIvZmllbGQvTWNGaWVsZC5qc3giXSwibmFtZXMiOlsiTWNGaWVsZCIsIkZpZWxkIiwiZGVmYXVsdFByb3BzIiwiY29tcG9uZW50IiwiRmllbGRGb3JtIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQ0E7O0FBRUE7Ozs7OztBQUVBOzs7SUFHcUJBLE87Ozs7Ozs7OztFQUFnQkMsZ0I7QUFOckM7OztBQU1xQkQsTyxDQUNWRSxZLEdBQWU7QUFDbEJDLGVBQVdDO0FBRE8sQztrQkFETEosTyIsImZpbGUiOiJNY0ZpZWxkLmpzIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQGZsb3dcbmltcG9ydCB7IEZpZWxkIH0gZnJvbSAncmVkdXgtZm9ybSdcbi8vIGltcG9ydCBGb3JtRmllbGQgZnJvbSAnLi9Gb3JtRmllbGQnXG5pbXBvcnQgRmllbGRGb3JtIGZyb20gJy4uL2Zvcm0vRmllbGRGb3JtJ1xuXG4vKipcbiAqIEBkZXByZWNhdGVkXG4gKi9cbmV4cG9ydCBkZWZhdWx0IGNsYXNzIE1jRmllbGQgZXh0ZW5kcyBGaWVsZCB7XG4gICAgc3RhdGljIGRlZmF1bHRQcm9wcyA9IHtcbiAgICAgICAgY29tcG9uZW50OiBGaWVsZEZvcm1cbiAgICB9XG59XG4iXX0=